import styled from "styled-components";
import logo from "../../resources/logo.png";

export const Footers = styled.footer`
  height: 99px;
  width: 100%;
  border-top: 1px solid #abafb4;
  background-color: rgba(46, 54, 67, 1);
  @media only screen and (max-width: 768px) {
    height: 20%;
  }
  margin-top: 300px;

  @media only screen and (max-width: 1000px) {
    display:none;
    }
`;

export const Container = styled.div`
  width: 70%;
  padding-top: 30px;
  height: 100%;
  display: grid;
  grid-template-columns: 80px 5fr minmax(90px, 1fr) 1fr;
  margin: 0 auto;
  // @media only screen and (max-width: 768px) {
  //   width: 100%;
  //   align-items: center;
  //   padding-top: 10px;
  // }


`;

export const Logo = styled.div`
  width: 102px;
  height: 14px;
  margin-top: 13px;
  margin-left: -10px;
  background-image: url(${logo});
  background-size: cover;
  @media only screen and (max-width: 768px) {
    margin-left: 5px;
  }
`;

export const Text = styled.div`
  color: white;
  font-size: 12px;
  margin-left: 30px;
  & > p {
    margin-bottom: 5px;
  }
  & > p > span {
    display: inline-block;
    margin-right: 10px;
  }
  @media only screen and (max-width: 768px) {
    margin-left: 15px;
  }
`;

export const Copyright = styled.span`
  color: rgba(62, 135, 146, 1);
`;

export const Combo = styled.select`
  width: 100%;
  height: 24px;
  background-color: rgba(46, 54, 67, 1);
  border: 1px solid #585d65;
  color: #3f8893;
`;

export const Icons = styled.ul`
  justify-self: end;
  display: grid;
  grid-template-columns: repeat(3, 36px);
  margin-left: 10px;
  height: 100%;
  gap: 13px;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 36px);
    gap: 5px;
  }

  @media only screen and (max-width: 480px) {
    grid-template-columns: repeat(1, 36px);
    gap: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Icon = styled.li`
  width: 36px;
  height: 36px;
  cursor: pointer;
  background-image: url(${(props) => props.icon});
`;
